module.exports = __webpack_public_path__ + "static/media/logo.2174d6a1.svg";